import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { guid } from '@/mixins/guid';
import dropsLoader from '@/mixins/components/drops-loader';

export default Vue.component('invite-content-user', {
  template: require('./template.html'),
  name: 'invite-content-user',
  mixins: [guid],
  components: {
    dropsLoader,
  },
  computed: {
    ...mapGetters([
      'websites',
      'currentUser',
      'subUsers',
    ]),
  },
  props: ['modal', 'toggle-modal'],
  data() {
    return {
      loading: false,
      subuser: '',
      searchLoader: false,
      searchError: false,
      userResults: [],
      searched: false,
    };
  },
  methods: {
    findUser() {
      this._debounce(() => {
        if (this.subuser.replace(/\s+/g) === '') {
          return;
        }
        this.$validator.validate('subuser', this.subuser).then(async (result) => {
          if (result) {
            this.searchLoader = true;
            this.searchError = false;
            try {
              const { results } = await this.$lightning([{
                name: 'searchDrzzleUsers',
                payload: {
                  email: this.subuser,
                },
              }]);
              this.searched = true;
              this.userResults = results;
            } catch (e) {
              const message = e.message || e;
              this.$log.error(message);
              this.searchError = message;
              await this._reportError({
                error: e,
                fn: 'Find Drzzle user. Invitet Sub-users',
              });
            } finally {
              this.searchLoader = false;
            }
          }
        });
      }, 300);
    },
    async inviteToWorkspace(subUser) {
      try {
        subUser.loading = true;
        await this.$lightning([{
          name: 'inviteToWorkspace',
          payload: { subUser },
        }]);
        const newUser = _.cloneDeep(subUser);
        this.$store.dispatch('setGlobalValue', {
          array: true,
          item: this.currentUser,
          key: 'subUsers',
          value: newUser,
        });
        const subUsers = this.subUsers;
        this.$store.dispatch('runStateFn', {
          fn() {
            subUsers.push(newUser);
          },
        });
      } catch (e) {
        const message = e.message || e;
        this.$log.error(message);
      } finally {
        subUser.loading = false;
      }
    },
    notAdded(user) {
      const added = this.currentUser.subUsers.find(subUser => subUser._id === user._id);
      return !added;
    },
    closeModal(type) {
      this.$emit('toggle-modal', type, 'child');
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/sub-users/invite/content-editor/index.js